import React, { FC, useState, useEffect } from 'react'
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  List,
  ListItemButton,
  useTheme,
} from '@mui/material'
import { Search as SearchIcon } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux'
import { AmericanStatesActions, AmericanStatesSelector } from '../../store/AmericanStates'
import { MapActions } from '../../store/Map'
import { WaterSystemCoordinatesActions } from '../../store/publicWaterSystem'
import { WaterSystemsMetricsActions } from '../../store/publicWaterSystem'
import { WaterSystemsActions, WaterSystemsSelector, WaterSystemType } from '../../store/waterSystems'
import { WellWaterSystemsMetricsActions } from '../../store/wellWaterSystem'
import { CountyActions } from '../../store/County'

interface StatesSearchProps {
    handleClose: () => void; 
  }

export const StatesSearch: FC<StatesSearchProps> = ({ handleClose }) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const states = useSelector(AmericanStatesSelector.makeSortedStates)
  const fetchingStates = useSelector(AmericanStatesSelector.fetchingStates)
  const waterSystemType = useSelector(WaterSystemsSelector.getSelectedWaterSystemType)
  const [searchQuery, setSearchQuery] = useState('')

  useEffect(() => {
      dispatch(AmericanStatesActions.fetchAmericanStatesAsync() as any)
    }, [dispatch])

  const filteredStates = searchQuery
    ? states.filter((state) =>
        state.state.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : states

  const handleStateChange = (stateId: string) => {
    const selectedState = states.find((state) => state._id === stateId)
    if (!selectedState) return
    resetSearchedData()
    dispatch(AmericanStatesActions.setSelectedState(selectedState))

    if (selectedState.location) {
      const [lat, lng] = selectedState.location
      const zoom = selectedState.default_zoom
      dispatch(MapActions.setMapCenter({ lat, lng }))
      dispatch(MapActions.setMapZoom({zoom}))
      dispatch(CountyActions.setSelectedCounty(''))
    }

    const options = {
      params: {
        state_abbr: selectedState?.state_abbr,
      },
    }

  
    if(waterSystemType === WaterSystemType.WELL){
      dispatch(WellWaterSystemsMetricsActions.fetchWellWaterSystemMetricsAsync({ options }) as any)
    }else{
      dispatch(WaterSystemsMetricsActions.fetchWaterSystemMetricsAsync({ options }) as any)
    }
    handleClose()
  }

  const resetSearchedData = () => {
    dispatch(WaterSystemsActions.setSelectedWaterSystem(''))
    dispatch(WaterSystemsActions.resetWaterSystemsData())
    dispatch(WaterSystemsActions.setUserSearched(false))
    dispatch(WaterSystemsMetricsActions.resetWaterSystemMetricsData())
    dispatch(WaterSystemCoordinatesActions.resetWaterSystemCoordinates())
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 500,
          marginBottom: '8px',
          color: theme.palette.text.primary,
        }}
      >
        View map by state
      </Typography>
      <TextField
        fullWidth
        size="small"
        placeholder="Search states..."
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={{
          marginBottom: '16px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E2E8F0 !important',
          },
        }}
      />
      {fetchingStates ? (
        <Typography>Loading states...</Typography>
      ) : (
        <List
          sx={{
            maxHeight: '300px',
            overflowY: 'auto',
            backgroundColor: '#FFF',
            // borderRadius: '8px',
            // boxShadow: theme.shadows[1],
          }}
        >
          {filteredStates.map((state) => (
            <ListItemButton
              key={state._id}
              onClick={() => handleStateChange(state._id)}
              sx={{
                fontSize: '14px',
                padding: '8px 16px',
                color: theme.palette.secondary.dark,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              {state.state}
            </ListItemButton>
          ))}
        </List>
      )}
    </Box>
  )
}